import { ChangeDetectorRef, Component, computed, OnDestroy, signal, TemplateRef, ViewChild, effect } from '@angular/core';
import { GroupNotificationService } from './n-group.service';
import { CompanyService } from '../../configuration/company/company.service.service';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { getCode } from 'app/utils/method';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import { IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import DistributionChainAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity';
import { DistributionChainService } from '../../configuration/distribution-chain/distribution-chain.service';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import { SalesOfficeService } from '../../configuration/sales-office/sales-office.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ICreateGroupNotification, IUpdateGroupNotification } from './interfaces/group-interface';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { NGMembersComponent } from './ng-members/ng-members.component';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { NotificationsFiltersComponent } from '../../filters/notifications-filters/notifications-filters.component';
import NotificationMemberAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-member/notification-member.entity';
import { MemberNotificationService } from '../n-member/n-member.service';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import NotificationGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-group/notification-group.entity";

import ShortNotificationMemberAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-member/short-notification-member/short-notification-member.short.entity";
import { forkJoin, of, map, catchError } from 'rxjs';

@Component({
  selector: 'app-n-group',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    MatTabsModule,
    MatBadgeModule,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    FilterComponent,
    NotificationsFiltersComponent,
    HoverMenuDirective
  ],
  templateUrl: './n-group.component.html',
  styleUrl: './n-group.component.scss'
})
export class NGroupComponent implements OnDestroy {
  getCode = getCode
  displayedColumns: string[] = [
    "name",
    "company",
    "members",
    "statusId", 
    "action"
  ];

  dataSource = new MatTableDataSource<any>([]);
  private groupsData = signal <any[]>([]);
  private activeMembersMap = signal<Map<string, ShortNotificationMemberAttributes[]>>(new Map());
  processedGroups = computed(() => {
    const groups = this.groupsData();
    const membersMap = this.activeMembersMap();
    
    return groups.map(group => ({
      ...group,
      activeMembersCount: membersMap.get(group._id?.toString())?.length || 0
    }));
  });

  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof any = "company";
  sortDirection: "ASC" | "DESC" = "ASC";

  companyList: CompanyAttributes[] = []
  companyFilterList: CompanyAttributes[] = []
  listDistributionChain: DistributionChainAttributes[];
  salesOfficeList: SalesOfficeAttributes[] = [];
  listFilterSalesOfficeList = signal<SalesOfficeAttributes[]>([]);
  searchOffice = ''

  currentGroupN: ICreateGroupNotification = this.initializeCreateGroup();
  public id: any = null

  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;

  //BUSCADOR
  searchSubscription: Subscription;
  selectedStatuses: number[] = [];
  form: FormGroup;
  notificationMemberList: NotificationMemberAttributes[] = [];
  
  constructor(
    private groupNotificationService: GroupNotificationService,
    private readonly companyService: CompanyService,
    private readonly distributionChainService: DistributionChainService,  
    private readonly salesOfficeService: SalesOfficeService,  
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private readonly cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private memberNotificationService: MemberNotificationService
  ) {
    this.form = this.fb.group({
      companyId: [],
      distributionChainId: [],
      salesOfficeId: [],      
      notificationMemberId: []
    });

    effect(()=>{
      this.dataSource.data = this.processedGroups();
      this.cdr.detectChanges();
    })
  }

  ngAfterViewInit(): void {
    this.onHandleSearch()
    this.fetchNotificationMembers();
    this.getList();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getList()
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  fetchNotificationMembers(): void {
      const filter: IFilters = {
    status: [1]  
  };

  this.memberNotificationService.getAllPaginate(
    {
      currentPage: 1,
      limitPerPage: Number.MAX_SAFE_INTEGER,
      sort: "name",
      sortDirection: "ASC"
    },
    filter
  ).subscribe((res: IPaginationResult<NotificationMemberAttributes>) => {
    this.notificationMemberList = res?.data?.[0]?.data ?? [];
  });
      
    }
    

  onClearEvent() {
    this.selectedStatuses = [];
    this.form.reset();
    this.pageIndex = 1;
    this.getList();
  }

  /*getList(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    let dataToFilter: IFilters = {
          companyId: this.form.get("companyId")?.value, // Corregido: era "compnayId"
          salesOfficeId: this.form.get("salesOfficeId")?.value,
          distributionChainId: this.form.get("distributionChainId")?.value,
          status: this.selectedStatuses,
          notificationMemberId: this.form.get("notificationMemberId")?.value
        }

    this.groupNotificationService.getAllPaginate(options,
      dataToFilter
    ).subscribe({
      next: (res: IPaginationResult<any>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener grupos","Cerrar",{ duration: 5000});
      },
    })
  }*/
  
getList(): void {
  let options = { 
    currentPage: this.pageIndex, 
    limitPerPage: this.pageSize, 
    search: this.search, 
    sort: this.sortActive, 
    sortDirection: this.sortDirection 
  }

  let dataToFilter: IFilters = {
    companyId: this.form.get("companyId")?.value,
    salesOfficeId: this.form.get("salesOfficeId")?.value,
    distributionChainId: this.form.get("distributionChainId")?.value,
    status: this.selectedStatuses,
    notificationMemberId: this.form.get("notificationMemberId")?.value
  }

  this.groupNotificationService.getAllPaginate(options, dataToFilter).subscribe({
    next: (res: IPaginationResult<NotificationGroupAttributes>) => {
      const groups = res?.data?.[0]?.data ?? [];
      this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      this.groupsData.set(groups);
      this.performCrossFiltering(groups);
    },
    error: (err) => {
      this.snackBar.open(err.error.message || "Error al obtener grupos","Cerrar",{ duration: 5000});
    },
  })
}

private performCrossFiltering(groups: NotificationGroupAttributes[]): void {
  if (!groups.length) {
    this.activeMembersMap.set(new Map());
    return;
  }
  const memberRequests = groups.map(group => {
    const companyId = group.company?._id || group.company?.id;
    
    if (!companyId) {
      return of({ groupId: group._id?.toString(), activeMembers: [] });
    }
    return forkJoin({
      activeMembers: this.memberNotificationService.getCombo({ companyId: companyId.toString() }),
      groupMembers: this.groupNotificationService.getMembersByGroupId(group._id?.toString())
    }).pipe(
      map(({ activeMembers, groupMembers }) => {
        const activeMembersInGroup = groupMembers.data?.filter(memberInGroup =>
          activeMembers.data?.some(activeMember => 
            activeMember._id?.toString() === memberInGroup._id?.toString()
          )
        ) || [];
        return {
          groupId: group._id?.toString(),
          activeMembers: activeMembersInGroup
        };
      }),
      catchError(error => {
        this.snackBar.open('Error no se encontraron miembros dentro del grupo ', 'Cerrar', { duration: 3000 });
        return of({ groupId: group._id?.toString(), activeMembers: [] });
      })
    );
  });

  forkJoin(memberRequests).subscribe({
    next: (results) => {
      const newMembersMap = new Map<string, ShortNotificationMemberAttributes[]>();
      results.forEach(result => {
        newMembersMap.set(result.groupId, result.activeMembers);
      });
      this.activeMembersMap.set(newMembersMap);
    },
    error: (error) => {
      this.snackBar.open('Error no se encontraron miembros registrados', 'Cerrar', { duration: 3000 });
      this.activeMembersMap.set(new Map());
    }
  });
}

  getActiveMembersCount(groupId: string): number {
    return this.activeMembersMap().get(groupId?.toString())?.length || 0;
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  private initializeCreateGroup(): ICreateGroupNotification {
    return { 
      code: "", 
      externalKey: null,
      companyId: null,
      members: [], 
      name: null,
    };
  }

  onMembersChange(selectedMembers: any[]): void {
    const memberIds = selectedMembers ? selectedMembers.map(id => 
      typeof id === 'string' ? id : (id?._id?.toString() || id?.toString())
    ) : [];
    
    this.currentGroupN.members = memberIds;
  }


  trackByMemberId(index: number, member: NotificationMemberAttributes): string {
    return member._id?.toString() || index.toString();
  }

  //start filter
  getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        this.companyFilterList = this.companyList.slice();
      },
      error: (err) => {
        this.snackBar.open('Error no se encontraron compañias', 'Cerrar', { duration: 3000 });
      }
    });
  }

  private fetchAllDistributionChain() {
    this.distributionChainService.findToComboBox().subscribe({
      next: (res) => {
        this.listDistributionChain = res.data;
      },
    });
  }

  getAllSalesOfficeList(companyId: string): void {
    this.salesOfficeService.findToComboBox(companyId).subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
        this.listFilterSalesOfficeList.update(()=> this.salesOfficeList.slice());
      },
      error: (err) => {
        this.snackBar.open('Error no se encontraron compañias', 'Cerrar', { duration: 3000 });
      },
    });
  }
  
  changueOptionsSalesOffice(event){
    if (!this.salesOfficeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSalesOfficeList.update(() => this.salesOfficeList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSalesOfficeList.update(() => this.salesOfficeList.filter(item => item.externalKeys?.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1))
  }
  //end Filter
  
  openModal(groupN?: any): void {
    this.getAllCompanies()
    this.fetchAllDistributionChain()

    if(groupN){
      this.currentGroupN = {
        ...groupN,
        code: groupN.code,
        externalKey: this.getCode(groupN) ? this.getCode(groupN) : null,
        companyId: groupN.company ? groupN.company._id.toString() : "",
        members: groupN.members ? 
          (Array.isArray(groupN.members) ? 
            groupN.members.map(member => 
              typeof member === 'string' ? member : member._id?.toString() || member.id?.toString()
            ) : []
          ) : []
      };
      this.id = groupN._id;
      if(groupN.company?._id) {
        this.getAllSalesOfficeList(groupN.company._id.toString());
      }

    } else {
      this.currentGroupN = this.initializeCreateGroup();
      this.id = null
    }

    this.dialogRef = this.dialog.open(this.actionModal, { width: '50%', disableClose: true })
    this.dialogRef.afterClosed().subscribe((result) => { result });
  }

  onSubmit(){
    if(this.id == null){
      this.createGroupN()
    }else{
      this.updateGroupN(this.id)
    }
  }

  createGroupN(): void {
  const newName = this.currentGroupN.name?.trim().toLowerCase();

  const exists = this.dataSource.data.some(
    (g: any) => g.name?.trim().toLowerCase() === newName
  );

  if (exists) {
    this.snackBar.open('Ya existe un grupo con ese nombre', 'Cerrar', { duration: 3000 });
    return; 
  }

  const dataToSend = {
    code: '', 
    externalKey: null,
    name: this.currentGroupN.name,
    companyId: this.currentGroupN.companyId,
    members: Array.isArray(this.currentGroupN.members) ? this.currentGroupN.members : []
  };

  this.groupNotificationService.create(dataToSend).subscribe({
    next: () => {
      this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
      if(this.dialogRef){
        this.dialogRef.close(true);
      }
      this.getList();
    },
    error: (err) => {
      this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
    }
  });
}

  
  updateGroupN(id: string): void {
    if (this.currentGroupN) {
      const updatedGroupN: IUpdateGroupNotification = {
        companyId: this.currentGroupN.companyId || null,
        members: Array.isArray(this.currentGroupN.members) ? this.currentGroupN.members : [], 
        name: this.currentGroupN.name || null,
      };

      this.groupNotificationService.update(id, updatedGroupN).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          if(this.dialogRef){
            this.dialogRef.close(true);
          }
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, groupN: any): void {
    const originalStatusId = groupN.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedGroupN = { 
      ...groupN, 
      statusId: updatedStatusId,
      name: groupN.name,
      members: Array.isArray(groupN.members) ? groupN.members.map(m => typeof m === 'string' ? m : (m?._id?.toString() || m?.toString())) : [],
      companyId: groupN.company ? groupN.company._id.toString() : null
    };

    this.groupNotificationService.update(groupN._id.toString(), updatedGroupN).subscribe({
      next: () => {
        this.getList();
      },

      error: () => {
        groupN.statusId = originalStatusId; 
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });
  }

  openDeleteDialog(groupN: any): void {
    this.dialog
      .open(this.deleteDialog, { data: groupN, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(groupN._id.toString()));
  }

  delete(id: string): void {
    this.groupNotificationService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  openMembersModal(groupN){
    const dialogRef = this.dialog.open(NGMembersComponent, {
      panelClass: "form-modal",
      data: groupN,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
      this.getList();
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}